export default __webpack_public_path__ + "static/media/automation-trimmed-linux.98e66f35.avif";